import {NavLink} from 'react-router-dom';

export const programacion =
<div>
<p>
    Siempre he estado interesado en la programación de computadores, empecé un poco tarde, pero una vez cursé la primera asignatura en la universidad relacionada con el tema,
    quedé atrapado por este mundo.
</p>

<p className="subTituloSeccion">
    Lenguajes y componentes de programación
</p>
<p>
    Estos son los lenguajes y componentes que he manejado en mi trayectoria como programador:
</p>
<p className='subSubTituloSeccion'>
    C++:
</p>
<p>
Con el que uno aprende. Como parte de la primera asignatura de la universidad, desarrollé los diferentes ejercicios y proyectos en este gran y tradicional lenguaje.
</p>
<p className='subSubTituloSeccion'>
    Visual Basic:
</p>
<p>
    Como parte de mi formación como Ingeniero Industrial, tuve la oportunidad de cursar una asignatura en la que aprendimos algo acerca de este lenguaje.
    Durante diferentes proyectos de las asignaturas que hicieron parte de la carrera, implementé diversos programas en este lenguaje. Siendo el lenguaje para 
    programación de macros en excel, éste me ha resultado útil en diversas situaciones de mi vida laboral y personal.
</p>
<p className='subSubTituloSeccion'>
    GISDK:
</p>
<p>
    Con este kit de desarrollo para el software <b>TransCAD</b>, he desarrollado diversas macros y funcionalidades en los proyectos de transporte en los que
    he trabajado, particularmente en temas de modelación de transporte privado y público de pasajeros y también lo relacionado con Sistemas de Información
    Geográfica. Es de los entornos de programación que más he disfrutado, una vez lo entiendes, el provecho que le puedes sacar es muy amplio; sus 
    funciones geográficas tienen un rendimiento altísimo y su uso es bastante intuitivo, cuando aprendes lo básico, las posibilidades se incrementan
    notablemente.
</p>
<p className='subSubTituloSeccion'>
    Python - ArcPy:
</p>
<p>
    Como experto en SIG y amante de la programación, entré al mundo de <b>python</b> gracias al paquete <b>ArcPy</b> del software <b>ArcGIS</b>. Esta
    herramienta me ha permitido automatizar diversos procesos geográficos bajo arquitecturas que manejan ese tipo de licenciamiento. Aunque soy un gran
    detractor del grupo <b>ESRI</b> y todos sus productos (próximamente escribiré un artículo acerca de esto), si estás en el mundo de los sistemas 
    geográficos, debes tener conocimiento de estas herramientas.
</p>
<p className="subSubTituloSeccion">
    ArcGIS API for JavaScript:
</p>
<p>
    Siguiendo con lo relativo al mundo de <b>SIG</b>, esta API permite desarrollar mapas WEB interactivos a la medida, es de la herramientas de <b>ESRI</b> que
    respeto un poco, su interacción con el lenguaje de cliente <b>JavaScript</b> permite hacer desarrollos muy particulares según diversas necesidades.
    He desarrollado diferentes visores geográficos usando esta tecnología y se pueden obtener buenos resultados en poco tiempo.
</p>
<p className="subSubTituloSeccion">
    JavaScript:
</p>
<p>
    El lenguaje de cliente, el que los navegadores entienden. Nos permite interactuar con elementos <b>HTML</b> y sus estilos. Este lenguaje ha evolucionado
    muchísimo y nos ofrece infinidades de opciones con miles de librerías que facilitan nuestro trabajo. En todas las aplicaciones WEB en las que he trabajado
    he tenido relación directa con este lenguaje, con cada nuevo proyecto voy fortaleciendo mi conocimiento.
</p>
<p className="subSubTituloSeccion">
    C#:
</p>
<p>
    El lenguaje de propósito general de <b>Microsoft</b>, el más usado para Programación Orientada a Objetos (<b>OOP</b> por sus siglas en inglés) de esta compañia.
    Aunque cuento solamente con las nociones básicas de la teoría de <b>OOP</b>, he logrado interactuar satisfactoriamente con este lenguaje en las aplicaciones
    WEB y de escritorio que he desarrollado. 
</p>
<p className="subSubTituloSeccion">
    ASP.NET:
</p>
<p>
    Con este Framework logré desarrollar algunas aplicaciones a nivel personal utilizando la variante <b>Web Forms</b>, ahora en mi vida laboral he implementado
    algunas aplicaciones WEB con el patrón Modelo-Vista-Controlador (<b>MVC</b>), esto con la última versión de <b>.NET Framework</b>. He realizado algunos 
    ejercicios para poder realizar mis próximos desarrollos con la versión <b>.NET Core 6.0</b>.   
</p>
<p className="subSubTituloSeccion">
    React JS:
</p>
<p>
    Una de las librerías más usadas de <b>JavaScript</b>, desarrollada y mantenida por Facebook. Debido a mi incursión en forma constante en el desarrollo de 
    aplicaciones WEB en los útlimos años, consideré fundamental aprender <b>React</b>, esta herramienta junto con los Frameworks <b>VUE</b> y <b>Angular</b> son las
    más usadas para el desarrollo de <b>Frontend</b> (lo que vemos de una página WEB) en la actualidad. Para esto encontré el que es tal vez el mejor profesor
    de programación, <b>Mosh Hamedani</b>, te contaré un poco más de él a continuación. Este website es la primera aplicación WEB que desarrollo con <b>React</b> después
    de haber terminado el curso completo de <b>Mosh</b>.
</p>
<p className="subSubTituloSeccion">
    Xamarin.Forms:
</p>
<p>
    Framework para desarrollar aplicaciones móviles multiplataforma. Buscando la forma de hacer mi primera aplicación móvil, encontré este componente y decidí iniciar mi proceso así. Buscando
    la forma de manejar el aspecto de almacenamiento encontré un tutorial para la implementación de bases de datos <b>Cosmos DB</b> en proyectos de Xamarin.Forms. Fue así que me embarqué en mi
    primer desarrollo y resulté publicando mi primera App móvil que sirve para llevar las cuentas de tu hogar o de tu grupo de amigos o familiares: <NavLink to="/apps_01">Cuentas Claras</NavLink>.
</p>


<p className="subTituloSeccion">
    Cursos recomendados
</p>
<p>
    Si estás interesado en aprender algún lenguaje de programación te recomiendo los cursos de <b>Mosh Hamedani</b>, son realmente buenos, si decides pagar
    por alguno de ellos, no te arrepentirás, en el siguiente enlace encuentras el sitio web para tomar estos cursos:
</p>
<p>
    <a href="https://codewithmosh.com/" target="_blank" rel="noreferrer">MOSH - Coding Made Simple</a>
</p>
<p>
    Si deseas conocer mejor su metodología antes de pagar, hay diversos cursos introductorios gratis en YouTUBE, allí también encontrarás unos pocos cursos completos,
    como el de Python:
</p>
<p>
    <a href="https://www.youtube.com/c/programmingwithmosh" target="_blank" rel="noreferrer">Programming with Mosh</a>
</p>


<p className="subTituloSeccion">
    Programas implementados
</p>
<p className="subSubTituloSeccion">
    Windows:
</p>
<p>
    A continuación te comparto algunos de los primeros programas para Windows que desarrollé en Visual Basic y C#. Para usarlos, descomprime el archivo (.exe)
    y ubícalo en una carpeta de tu preferencia, si te sale algún aviso de seguridad, continua sin problema, te aseguro que no es un archivo peligroso para 
    tu dispositivo. ¡Ejecuta el archivo y listo!.
</p>
<ul>
    <li>
        <b>Oruga:</b> Juego para Windows basado en <a href="https://en.wikipedia.org/wiki/Nibbles_(video_game)" target="_blank" rel="noreferrer">Nibbles</a> desarrollado originalmente 
        en <b>QBasic</b>. Trata de una Oruga que avanza en la dirección que le indiques, tienes que evitar que choque con cualquier obstáculo, 
        para avanzar de nivel debes atrapar 10 frutas que aparecerán secuencialmente cada vez que atrapes una nueva. Ten cuidado, cada vez que atrapes una 
        fruta, la oruga será más larga. Descárgalo <a href="https://drive.google.com/uc?export=view&id=1Oi5h_qdDu4qGZ0MQY9k-rHdCW26mIq0L">aquí</a>.
        Para iniciar el juego presiona F2 (como en todo juego antiguo para Windows). 
        Las teclas por defecto para indicar la dirección a la oruga son <b>i j k l</b>, con la tecla <b>t</b> puedes aplicar/quitar la velocidad turbo. 
        Puedes cambiar la velocidad general y ajustar las teclas para controlar la oruga.
    </li>
    <li>
        <b>Columnas de excel:</b> Ingresa la(s) letra(s) de la columna de Excel y podrás visualizar el número de columna. 
        Descárgalo <a href="https://drive.google.com/uc?export=view&id=1V9Ei2JUQaa89vvnVF5XeAN3KHQKB0Pa3">aquí</a>.
    </li>
    <li>
        <b>Cronómetro miniatura:</b> Cronómetro regresivo. Configura las horas, minutos y segundos (Botón azul aumenta, naranja disminuye), inicia (Botón verde)
        y pausa (Botón rojo). También puedes ubicarlo en las esquinas de tu pantalla con el botón de la flecha.
        Descárgalo 
    </li>
    <li>    
        <b>Sincronizador de archivos:</b> Sincroniza tus carpetas de Windows. Lo utilizo constantemente para tener una copia de los archivos de mi computador
        en un disco externo. Descárgalo <a href="https://drive.google.com/uc?export=view&id=1d1T_8kuoRqX6zq189ouzRNbPPE1RyjZz">aquí</a>.
        Selecciona tu carpeta origen y tu carpeta de destino. Espera a que se comparen las carpetas, verde es coincidente y rojo es diferente, en ubicación
        cambia el color si los nombres de sub-carpetas y nombres de archivos son idénticos o no, en tamaño cambia el color según la
        coincidencia en el tamaño exacto entre carpeta origen y destino. Utiliza el comando "Copiar faltantes en destino" para copiar los archivos de la 
        carpeta origen que no estén en la carpeta destino, una vez finalizado este proceso, puedes usar el comando "Borrar sobrantes destino" para borrar
        los archivos de la carpeta destino que no estén en la carpeta origen.
    </li>
    <li>
        <b>Visor de imágenes:</b> Abre tus archivos de imagen con este sencillo visor. Es rápido y funciona solamente con atajos del teclado.
        Descárgalo <a href="https://drive.google.com/uc?export=view&id=1jyPaz8TdSiFcxhM3YtyICgXtCknDYGo4">aquí</a>. Para abrir una imagen pulsa Ctrl+O,
        para avanzar o retroceder a otra imagen de la misma carpeta usa las teclas derecha e izquierda, para hacer zoom usa la rueda del mouse, para
        hacerlo con mayor precisión házlo manteniendo la tecla Ctrl oprimida; usa el comando Ctrl+Z para intercalar entre el zoom máximo y mínimo, oprime
        Ctrl+Tab para girar la imagen (quedará girado el archivo original), usa Ctrl+Borrar(Flecha atrás) para borrar la imagen (se mostrará aviso de confirmación),
        finalmente, oprime Ctrl+P para abrir la imagen en Paint. Este programa no funciona apropiadamente para imágenes excesivamente grandes (no te preocupes por esto,
        todas las imágenes de tu cámara o célular las podrás abrir sin problema), mientras tengas abierto un archivo con este programa no podrás editarlo con otro.
        Puedes utilizarlo como tu visor de imágenes predeterminado (consulta <a href="https://support.microsoft.com/es-es/windows/cambiar-los-programas-predeterminados-en-windows-10-e5d82cad-17d1-c53b-3505-f10a32e1894d" target="_blank" rel="noreferrer">aquí</a> cómo hacerlo).
    </li>
</ul>
<p className="subSubTituloSeccion">
    Aplicaciones WEB:
</p>
<p>
    También te comparto el enlace de una de las aplicaciones WEB que desarrollé en mi paso por la Defensoría del Pueblo de Colombia, allí podrás consultar
    las variables clave de las Alertas Tempranas emitidas por la entidad. Esta aplicación está desarrollada en <b>ASP.NET MVC</b>, está desplegada en <b>Azure</b> como
    una WebApp y utiliza el módulo <b>DevOps</b> para integración y entrega continua, también usa el componente <b>Blob Storage</b> para el almacenamiento
    de documentos, los datos están almacenados en un servicio <b>SQL Azure</b> y tiene integrados unos tableros de <b>Power BI</b>; también tiene incorporado
    un componente geográfico soportado en una arquitectura de SIG basada en tecnología de ESRI:
</p>
<p>
    <a href="https://alertastempranas.defensoria.gov.co/" target="_blank" rel="noreferrer">Alertas Tempranas - Defensoría del Pueblo de Colombia</a>
</p>
<p className="subSubTituloSeccion">
    Aplicaciones móviles:
</p>
<p>
    <b>Cuentas Claras</b>: App para llevar las cuentas de tu hogar o de tu grupo de amigos o familiares. Lleva el balance de gastos conjuntos y préstamos personales; úsala en el hogar, en tus viajes y mucho más.
    Disponible en <b>Android</b>, <b>Windows</b> y próximamente en <b>iOS</b>. Descárgala <NavLink to="/apps_01">aquí</NavLink>.
</p>
</div>





